<template>
  <!--  https://regenrek.com/posts/how-to-create-an-animated-vue-sidebar-menu-with-vue-observable/-->
  <div
    id="burger"
    :class="{ active: isBurgerActive }"
    @click.prevent="onUserClick"
  >
    <slot>
      <button type="button" class="burger-button">
        <span class="burger-bar burger-bar--1"></span>
        <span class="burger-bar burger-bar--2"></span>
        <span class="burger-bar burger-bar--3"></span>
      </button>
    </slot>
  </div>
</template>
<script>
export default {
  name: "BurgerButton",
  data() {
    return {
      isBurgerActive: false
    };
  },
  props: {
    isActive: { required: false, type: Boolean, default: false }
  },
  watch: {
    isActive(val) {
      this.isBurgerActive = val;
    }
  },
  mounted() {
    this.isBurgerActive = this.isActive;
  },
  methods: {
    onUserClick() {
      this.$emit("eventOnUserClick", !this.isBurgerActive);
    }
  }
};
</script>
<style>
.hidden {
  visibility: hidden;
}

button {
  cursor: pointer;
}

/* remove blue outline */
button:focus {
  outline: 0;
}

.burger-button {
  position: relative;
  height: 30px;
  width: 32px;
  display: block;
  z-index: 999;
  border: 0;
  border-radius: 0;
  background-color: transparent;
  pointer-events: all;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.burger-bar {
  background-color: var(--textinactive);
  position: absolute;
  top: 50%;
  right: 6px;
  left: 6px;
  height: 2px;
  width: auto;
  margin-top: -1px;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1),
    opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1),
    background-color 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.burger-bar--1 {
  -webkit-transform: translateY(-6px);
  transform: translateY(-6px);
}

/*.burger-bar--2 {*/
/*  transform-origin: 100% 50%;*/
/*  transform: scaleX(0.8);*/
/*}*/

/*.burger-button:hover .burger-bar--2 {*/
/*  transform: scaleX(1);*/
/*}*/

/*.no-touchevents .burger-bar--2:hover {*/
/*  transform: scaleX(1);*/
/*}*/

.burger-bar--3 {
  transform: translateY(6px);
}

#burger.active .burger-button {
  transform: rotate(-180deg);
}

#burger.active .burger-bar {
  background-color: var(--textactive);
}

#burger.active .burger-bar--1 {
  transform: rotate(45deg);
}

#burger.active .burger-bar--2 {
  opacity: 0;
}

#burger.active .burger-bar--3 {
  transform: rotate(-45deg);
}

.burger-bar:hover,
.burger-bar:focus:hover {
  color: var(--symmetry-h) !important;
}
</style>
